import pt from "vuetify/lib/locale/pt";

const AQTechThemeConfig = {
	breakpoint: {
		thresholds: {
			sm: 1248,
			md: 1428,
			lg: 1888
		}
	},
	lang: {
		locales: { pt },
		current: "pt",
	},
	icons:            { iconfont: "mdi" },
	customProperties: true,
	theme:            {
		dark:   false,
		themes: {
			light: {
				primary:        "#F9FAFC",
				secondary:      "#516378",
				accent:         "#00be00",
				error:          "#db5050",
				info:           "#102A43",
				success:        "#4bc932",
				warning:        "#ecd225",
				background:     "#D9E2EC",
				disabled:       "#696969",
				undefined:      "#9FB3C8",
				onWarning:      "#102A43",
				onError:        "#F0F4F8",
				onSuccess:      "#102A43",
				onUndefined:    "#102A43",
				onDisabled:     "#102A43",
				rangeLevelA:    "#2BA52B",
				rangeLevelB:    "#99EE24",
				rangeLevelC:    "#F9D230",
				rangeLevelD:    "#DC1600",
				rangeUndefined: "#D2D2D2",
				rangeDisabled:  "#696969",
				messageinfo:    "#0079C7",
			},
			dark: {
				primary:        "#102A43",
				secondary:      "#BCCCDC",
				accent:         "#00be00",
				error:          "#db5050",
				info:           "#243B53",
				success:        "#06345f",
				warning:        "#c0aa1c",
				background:     "#031424",
				disabled:       "#7a6767",
				undefined:      "#6d7986",
				onWarning:      "#102A43",
				onError:        "#BCCCDC",
				onSuccess:      "#102A43",
				onUndefined:    "#BCCCDC",
				onDisabled:     "#031424",
				rangeLevelA:    "#2BA52B",
				rangeLevelB:    "#99EE24",
				rangeLevelC:    "#F9D230",
				rangeLevelD:    "#DC1600",
				rangeUndefined: "#D2D2D2",
				rangeDisabled:  "#696969",
				messageinfo:    "#0079C7",
			},
		},
	},
};
export default { AQTechThemeConfig };